import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Waves } from '@material-ui/icons';
import ReactGA from 'react-ga';
import { Actions as Imagery } from '../../../store/ducks/imagery';
import { Button } from '@material-ui/core';
/**
 *
 * @function SelectImagesStep
 * @returns {JSX.Element} Coastline Analysis steps JSX element
 */
const SelectImagesStep = ({ t, onNext, isCurrent }) => {
  const selectedImages = useSelector((state) => state.results.chosenImages);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedImages?.length > 0) onNext();
  }, [selectedImages?.length]);

  return (
    <Button
      style={{ justifyContent: 'left' }}
      disabled={!isCurrent}
      color="primary"
      startIcon={<Waves />}
      onClick={() => {
        ReactGA.event({
          category: 'Actions',
          action: 'analyzeCoastline',
        });
        dispatch(Imagery.imageSelection());
      }}>
      {t('forms.imageChooser.actions.analyzeShoreline.imageSelection.title')}
    </Button>
  );
};

export default SelectImagesStep;
